module.exports = __webpack_public_path__ + "static/media/horrormax-banner-death-factory.42ff9512.jpg";